import * as signalR from '@microsoft/signalr';

import {ComponentUrls} from '@app/AppConstants';
import { appStore } from '@app/AppStore';
import { signalRUserStore } from '@app/Pages/HealthBoard/Store/SignalRUserStore';
import { jobStore } from '@app/Pages/JobList/Stores/JobStore';
import { NotificationHandler } from '../Components/ToastNotification';
import { JobStatusMessage } from '@app/Models';
import ApiService from './ApiService';
import { personStatusStore } from '@app/Stores/PersonStatusStore';

class SignalRService {
    private _hubConnection: signalR.HubConnection | null;
    
    initialize() {
        if (appStore.isAuthorized) {
            this.setUpHub();
        }
    }

    setUpHub() {
        const connectionUrl = location.origin +
            ComponentUrls.HubUrl +
            ComponentUrls.HubTokenQueryString +
            appStore.currentToken;

        const hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(connectionUrl)
            .build();

        hubConnection.on('success', (message: string) => {
            NotificationHandler.showSuccess(message, 'Success message');
        });
        hubConnection.on('warning', (message: string) => {
            NotificationHandler.showWarning(message, 'Warning message');
        });
        hubConnection.on('error', (message: string) => {
            NotificationHandler.showError(message, 'Error');
        });
        hubConnection.on('info', (message: string) => {
            NotificationHandler.showInfo(message, 'Info');
        });

        hubConnection.on('userDisconnected', () => {
            signalRUserStore.load();
        });
        hubConnection.on('userConnected', () => {
            signalRUserStore.load();
        });
        hubConnection.on('sendJobStatus', (job: JobStatusMessage) => {
            jobStore.updateJobStatus(ApiService.typeCheck(job));
        });
        hubConnection.on('sendJobProgressMaxValue', (triggerId: string, maxValue: number) => {
            jobStore.updateJobProgressMax(triggerId, maxValue);
        });
        hubConnection.on('sendJobProgressValue', (triggerId: string, value: number, maxValue: number) => {
            jobStore.updateJobProgressValue(triggerId, value, maxValue);
        });

        hubConnection.on('refreshPersonStatus', (personId: string, isPending: boolean, errorMessage?: string) => {
            personStatusStore.updatePersonStatus(personId, isPending, errorMessage);
        });

        let reconnectMessageTimer = 0;
        let reconnect = () => {
            window.setTimeout(() => {   
                this.setUpHub();
            }, 5000); // Restart connection after 5 seconds.
        };
        
        hubConnection.onclose(() => {
            appStore.showAppLoader('Connection to server was lost, reconnecting...');
            reconnect();
        });

        hubConnection.start().then(() => {
            if (reconnectMessageTimer) {
                clearTimeout(reconnectMessageTimer);
                reconnectMessageTimer = 0;
            }
            console.log('SignalR connected!');
            appStore.hideAppLoader();
            this._hubConnection = hubConnection;
        }, () => {
            reconnect();
        });
    }
}


export const signalRService = new SignalRService();